import CampaignShareTrigger from '@components/Campaign/Share/Trigger'
import InboxTitleBarMoreMenu from './../MoreMenu'
import { InboxTitleBardDownloadInstagramHandlesAction } from './DownloadInstagramHandlesAction'
import InboxTitleBarEditAction from './EditAction'
import { InboxTitleBarPreviewCampaignAction } from './PreviewCampaign'
import { InboxTitleBarToggleSelectionOptionAction } from './ToggleSelectionOptionAction'

interface IInboxTitleBarActionsProps {
  campaignId: number
  redirectToPreview: VoidFunction
  toggleSelectionMode: VoidFunction
}

export const InboxTitleBarActions = ({
  redirectToPreview,
  toggleSelectionMode,
  campaignId,
}: IInboxTitleBarActionsProps) => (
  <>
    <InboxTitleBardDownloadInstagramHandlesAction />
    <CampaignShareTrigger campaignId={campaignId} />
    <InboxTitleBarEditAction campaignId={campaignId} />
    <InboxTitleBarPreviewCampaignAction
      campaignId={campaignId}
      redirectToPreview={redirectToPreview}
    />
    <InboxTitleBarToggleSelectionOptionAction
      campaignId={campaignId}
      toggleSelectionMode={toggleSelectionMode}
    />
    <InboxTitleBarMoreMenu />
  </>
)

export default InboxTitleBarActions
